/* eslint-disable max-len */
import * as React from 'react';

import { createIcon, IIconProps, ISVGProps } from '../../internal';

const IconComponent = (props: ISVGProps) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72039 12.8871C4.50179 12.1057 5.5616 11.6667 6.66667 11.6667H13.3333C14.4384 11.6667 15.4982 12.1057 16.2796 12.8871C17.061 13.6685 17.5 14.7283 17.5 15.8334V17.5C17.5 17.9603 17.1269 18.3334 16.6667 18.3334C16.2064 18.3334 15.8333 17.9603 15.8333 17.5V15.8334C15.8333 15.1703 15.5699 14.5344 15.1011 14.0656C14.6323 13.5967 13.9964 13.3334 13.3333 13.3334H6.66667C6.00363 13.3334 5.36774 13.5967 4.8989 14.0656C4.43006 14.5344 4.16667 15.1703 4.16667 15.8334V17.5C4.16667 17.9603 3.79357 18.3334 3.33333 18.3334C2.8731 18.3334 2.5 17.9603 2.5 17.5V15.8334C2.5 14.7283 2.93899 13.6685 3.72039 12.8871Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0007 3.33335C8.61994 3.33335 7.50065 4.45264 7.50065 5.83335C7.50065 7.21407 8.61994 8.33335 10.0007 8.33335C11.3814 8.33335 12.5007 7.21407 12.5007 5.83335C12.5007 4.45264 11.3814 3.33335 10.0007 3.33335ZM5.83398 5.83335C5.83398 3.53217 7.69946 1.66669 10.0007 1.66669C12.3018 1.66669 14.1673 3.53217 14.1673 5.83335C14.1673 8.13454 12.3018 10 10.0007 10C7.69946 10 5.83398 8.13454 5.83398 5.83335Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

IconComponent.displayName = 'User';

export const User20: React.FunctionComponent<IIconProps> = createIcon(IconComponent);
